import type { SVGProps } from "react";

/**
 * Boil / simmer — pot with bubbling water and steam.
 */
export function BoilIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* Pot body */}
      <rect
        x={10}
        y={22}
        width={28}
        height={18}
        rx={3}
        fill="currentColor"
        opacity={0.15}
      />
      {/* Rim */}
      <rect
        x={8}
        y={20}
        width={32}
        height={4}
        rx={2}
        fill="currentColor"
        opacity={0.3}
      />
      {/* Handles */}
      <rect
        x={6}
        y={26}
        width={5}
        height={3}
        rx={1}
        fill="currentColor"
        opacity={0.5}
      />
      <rect
        x={37}
        y={26}
        width={5}
        height={3}
        rx={1}
        fill="currentColor"
        opacity={0.5}
      />
      {/* Water line */}
      <rect
        x={12}
        y={30}
        width={24}
        height={8}
        rx={0}
        fill="currentColor"
        opacity={0.2}
      />
      {/* Bubbles */}
      <circle cx={18} cy={28} r={2} fill="currentColor" opacity={0.5} />
      <circle cx={24} cy={26} r={1.5} fill="currentColor" opacity={0.4} />
      <circle cx={30} cy={28} r={2.5} fill="currentColor" opacity={0.5} />
      <circle cx={22} cy={31} r={1.5} fill="currentColor" opacity={0.3} />
      <circle cx={28} cy={32} r={1} fill="currentColor" opacity={0.35} />
      {/* Steam wisps */}
      <path
        d="M16 18c-1-3 1-6 0-8"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        opacity={0.4}
        fill="none"
      />
      <path
        d="M24 16c-1-3 1-6 0-8"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        opacity={0.3}
        fill="none"
      />
      <path
        d="M32 18c-1-3 1-6 0-8"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        opacity={0.4}
        fill="none"
      />
    </svg>
  );
}
